// World 9 (Quartz) — fifth paid-tier world. Shipped at the designed
// depth ramp thanks to the v0.4.4 solver heuristic upgrade. L1-L5 are
// d=8 openers spanning r=3 tile counts 13-15; L6-L10 are d=9 climaxes
// all on r=3 tile-15 boards (the densest geometry in the game). Six-
// color dominance (3/4 configs are 6c) is W9's distinguishing
// identity — "every cluster could merge" board reads.
// Generator: tools/generate-parallel.mjs --world 9. Seed 0xaebca000.
// 83 candidates pooled in ~14480s (4-worker pool, 180s solver budget).
// The (r=3, tileCount=15, 6-color) config was the star — 11 d=8 + 15 d=9
// accepted, which is the richest d=9 pool of any config run to date.
import type { LevelDef } from '@tessera/engine';
import { WORLD_9_GENERATED } from './world9-generated';

export const WORLD_9_LEVELS: LevelDef[] = [...WORLD_9_GENERATED];
